module.exports = __webpack_public_path__ + "6dce81db5b6e0b88b136e02cb693ba62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss06.jpg
// module id = 712
// module chunks = 0